import {
  FETCH_ARMS,
  FETCH_ARMS_SUCCESS,
  FETCH_ARMS_FAILURE,
  FOOTER_HEIGHT,
  FETCH_AVAILABLE_SERVICES_REQUEST,
  FETCH_AVAILABLE_SERVICES_SUCCESS,
  FETCH_AVAILABLE_SERVICES_FAILURE,
  START_ESERVICE,
  SUCCESS_ESERVICE,
  FAILURE_ESERVICE,
} from '../constants';

/* eslint-disable camelcase */

const InitialState = {
  arms: null,
  availableServices: [],
  areArmsFetching: false,
  areArmsFetched: false,
  isFetchingServices: false,
  footerHeight: 130,
  current: {
    isRunning: false,
    isServiceRequested: false,
    jobID: null,
    jobStatus: null,
  }
};

const armsRequest = state => ({
  ...state,
  areArmsFetching: true,
});
const armsSuccess = (state, action) => ({
  ...state,
  areArmsFetching: false,
  areArmsFetched: true,
  arms: action.payload,
});
const armsFailure = state => ({
  ...state,
  areArmsFetching: false,
  areArmsFetched: false,
});
const footerHeight = (state, action) => ({
  ...state,
  footerHeight: action.footerHeight,
});

const fAvailableServices_req = (state) => ({
  ...state,
  isFetchingServices: true,
})
const fAvailableServices_fail = (state) => ({
  ...state,
  isFetchingServices: false,
})
const fAvailableServices_success = (state, action) => ({
  ...state,
  isFetchingServices: false,
  availableServices: [...action.payload],
}); 

const start_eservice = state => ({
  ...state,
  current: {
    ...state.current,
    isServiceRequested: true,
  }
});

const success_eservice = (state, payload) => ({
  ...state,
  current: {
    ...state.current,
    isServiceRequested: false,
    isRunning: true,
    jobID: payload.message,
    jobStatus: 'STARTED',
  }
});

const failure_eservice = state => ({
  ...state,
  current: {
    ...state.current,
    isServiceRequested: false,
    isRunning: false,
  }
})

export default (state = InitialState, action) => {
  return ({
    [FETCH_ARMS]: armsRequest,
    [FETCH_ARMS_SUCCESS]: armsSuccess,
    [FETCH_ARMS_FAILURE]: armsFailure,
    [FETCH_AVAILABLE_SERVICES_REQUEST]: fAvailableServices_req,
    [FETCH_AVAILABLE_SERVICES_SUCCESS]: fAvailableServices_success,
    [FETCH_AVAILABLE_SERVICES_FAILURE]: fAvailableServices_fail,
    [FOOTER_HEIGHT]: footerHeight,
    [START_ESERVICE]: start_eservice,
    [SUCCESS_ESERVICE]: success_eservice,
    [FAILURE_ESERVICE]: failure_eservice,
  }[action.type] || (s => s))(state, action);
};



// WEBPACK FOOTER //
// src/reducers/eservices.js